import { render } from "./emptyComp.vue?vue&type=template&id=5d16f95e&scoped=true"
import script from "./emptyComp.vue?vue&type=script&lang=js"
export * from "./emptyComp.vue?vue&type=script&lang=js"

import "./emptyComp.vue?vue&type=style&index=0&id=5d16f95e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d16f95e"]])

export default __exports__